import React from 'react'

import makeStyles from '@material-ui/styles/makeStyles'

import { useGlobalState } from '../store'

import type { GlobalState } from '../types/globalState'

const useStyles = makeStyles({
  container: ({ theme }) => ({
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'center',
    padding: 32,
    backgroundColor: theme.colors.backgroundLight,
  }),
  containerFullScreen: {
    width: 'calc(100% - 64px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignContent: 'center',
  },
  title: ({ theme }) => ({
    color: theme.colors.primaryText,
    fontSize: '20px',
    fontWeight: 'bold',
    paddingTop: 16,
    marginBottom: 16,
  }),
  cta: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 64,
  },
})

type Props = {
  children: any,
  title?: string,
  fullScreen?: boolean,
  callToAction?: any,
}

const Page = ({ children, title, callToAction = null, fullScreen = false }: Props) => {
  const [theme]: [GlobalState] = useGlobalState('theme')
  const classes = useStyles({ theme })

  return (
    <div className={!!fullScreen ? classes.containerFullScreen : classes.container}>
      {title && <div className={classes.title}>{title}</div>}

      {children}

      {callToAction && (
        <div className={classes.cta}>
          {!!callToAction.length
            ? callToAction.map((i, index) => <React.Fragment key={index}>{i}</React.Fragment>)
            : callToAction}
        </div>
      )}
    </div>
  )
}

export default Page
